import { createUseStyles } from 'react-jss'
import { textSize, getThemedColor, color, config } from '@portal/kit/pkg/styles'

const { boxMobileMargin, boxMargin } = config.dimensions

export default createUseStyles(theme => ({
  catalog: {
    marginBottom: 24,
  },
  catalogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    cursor: 'pointer'
  },
  disabled: {
    ...color('textSecondary')
  },
  catalogIconActive: {
    color: theme.main_color
  },
  catalogIcon: {
    fontSize: 29
  },
  catalogText: {
    flexGrow: 1,
    marginLeft: boxMobileMargin
  },
  offersList: {
    display: 'flex',
    width: '100%',
    marginTop: (boxMargin - 8),
    flexWrap: 'wrap',
    gap: '8px'
  },
  offersListHidden: {
    display: 'none'
  },
  offerWrap: {
    width: 'calc(50% - 4px)',
    padding: '4px 3px',
  },
  offer: {
    position: 'relative',
    height: '100%',
    padding: '10px 12px 86px 12px',
    border: `1px solid ${getThemedColor(theme.theme, 'divider')}`,
    borderRadius: 4,
    textAlign: 'center',
  },
  offerName: {
    ...textSize(13, 15),
    ...color('titleColor', theme.theme),
    marginBottom: 8,
    letterSpacing: -0.13,
  },
  offerBuy: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 10,
  },
  offerPrice: {
    marginBottom: 10,
    ...textSize(30, 35),
    ...color('textSecondary'),
    letterSpacing: .6,

    '& sup': {
      ...textSize(16, 26),
    }
  },
  offerButtonState:{
    pointerEvents:'none',
    opacity: .4
  },

  devicesButtonArrow: {
    fontSize: 14,
    transitionDuration: '200ms',
    transformOrigin: 'center',
    ...color('textSecondary')
  },
  devicesButtonArrowUp: {
    transform: 'rotate(180deg)'
  },

  [config.mediaQueries.tabletPortrait]: {
    offerWrap: {
      width: 'calc(33.33333% - 6px)'
    },
    offersList: {
    },
  }
}))
